import React from 'react';
import { Typography, useTheme } from "@mui/material";

const ViewProfileHeading = (props) => {
  const theme = useTheme();
    return(
        <Typography variant="subtitle1" className="subtitle1" color="secondary" style={theme.palette.mode === 'dark' ? {color: theme.palette.text.primary} : {}}>
          {props.title ? props.title : ''}
        </Typography>
    )
}

export default ViewProfileHeading;
    
  